import { Flex, Table, Tag, Typography } from "antd";
import dayjs from "dayjs";

const STATUS_CONFIG = {
  pending: { label: "Menunggu Verifikasi", color: "warning" },
  accepted: { label: "Diterima", color: "success" },
  rejected: { label: "Ditolak", color: "error" },
  revised: { label: "Direvisi", color: "purple" },
};

const formatDateTime = (value) =>
  value ? dayjs(value).format("DD/MM/YYYY - HH.mm") : "-";

export default function VerificationHistoryTable({ history = [] }) {
  const columns = [
    {
      title: "No",
      width: 60,
      render: (_, __, index) => `${index + 1}.`,
    },
    {
      title: "Tanggal & Waktu Pengajuan",
      dataIndex: "time",
      width: 200,
      render: (val) => (
        <Typography.Text strong>{formatDateTime(val)}</Typography.Text>
      ),
    },
    {
      title: "Status Pengajuan",
      dataIndex: "status",
      width: 180,
      render: (val) => {
        const config = STATUS_CONFIG[val];
        return config ? (
          <Tag color={config.color}>{config.label}</Tag>
        ) : (
          <Tag>{val || "-"}</Tag>
        );
      },
    },
    {
      title: "Catatan Verifikasi",
      render: (record) => (
        <Typography.Text type="secondary">
          {record.reason ||
            (record.status === "accepted" ? "Verifikasi Berhasil" : "-")}
        </Typography.Text>
      ),
    },
    {
      title: "Verifikator",
      width: 200,
      render: (record) =>
        record.updatedBy ? (
          <Flex vertical>
            <Typography.Text strong>{record.updatedBy}</Typography.Text>
            <Typography.Text type="secondary" style={{ fontSize: 12 }}>
              {formatDateTime(record.time)}
            </Typography.Text>
          </Flex>
        ) : (
          "-"
        ),
    },
  ];

  return (
    <Table
      size="small"
      pagination={false}
      rowKey={(record, index) => record.id ?? index}
      columns={columns}
      dataSource={history}
      scroll={{ x: 800 }}
      locale={{ emptyText: "Belum ada riwayat verifikasi" }}
    />
  );
}
